<template>
  <b-card
    v-if="data"
    class="card-congratulation-medal"
  >
    <h5>{{ data.goal_center_name }} 排名</h5>

    <h1 class="mb-75 mt-2 mb-6 pt-50">
      <b-link>{{ data.rank }}</b-link>
    </h1>
    <h5 class="mb-75 mb-6 pt-50">
      <b-link style="color:#888;">本月共有 {{ data.total_center }} 間分校</b-link>
    </h5>

    <b-img
      :src="require('@/assets/images/illustration/badge.svg')"
      class="congratulation-medal"
      alt="Medal Pic"
    />
  </b-card>
</template>

<script>
import {
  BCard, BCardText, BLink, BButton, BImg,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { kFormatter } from '@core/utils/filter'

export default {
  components: {
    BCard,
    BCardText,
    BLink,
    BImg,
    BButton,
  },
  directives: {
    Ripple,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    kFormatter,
  },
}
</script>
